import React from 'react';
import clsx from 'clsx';
import MuiTypography from '@material-ui/core/Typography';
import { TEXT } from 'ctsutheme/core';

const Typography = ({
  className,
  bold,
  inline,
  link,
  linkInverted,
  icon,
  inverted,
  indented,
  indentedLarge,
  light,
  lightWeight,
  primary,
  secondary,
  tertiary,
  success,
  danger,
  header,
  withSeperator,
  ...props
}) => (
  <MuiTypography
    component="div"
    className={clsx(
      TEXT.root,
      className,
      bold && TEXT.bold,
      inline && TEXT.inline,
      icon && TEXT.icon,
      link && TEXT.link,
      linkInverted && TEXT.linkInverted,
      inverted && TEXT.inverted,
      indented && TEXT.indented,
      indentedLarge && TEXT.indentedLarge,
      primary && TEXT.primary,
      secondary && TEXT.secondary,
      success && TEXT.success,
      danger && TEXT.danger,
      header && TEXT.header,
      withSeperator && TEXT.withSeperator
    )}
    {...props}
  />
);

export default Typography;
